export default {
    fund: [{
            "title": "关于创业投资估值法，以下表述正确的是（　　）。",
            "question": "A. 简够适用于该估值法的目标公司未来回报一定很高\nB. 仅适用于创业投资基金，不适用于并购基金\nC. 通常适用于创立约3-5年的企业\nD. 目标公司确有财务状况与估值结果无关",
            "answer": "B",
            "explain": "本题考查创业投资估值法。如果股权投资基金拟投资的目标公司处于创业早期，利润和现金流均为负数，未来回报很高，但存在高度不确定性，往往会用创业投资估值法。"
        },
        {
            "title": "关于公司型股权投资基金，表述错误的是（　　）。",
            "question": "A. 基金管理人必须委托专业基金管理机构担任\nB. 公司型股权投资基金按公司章程来运营\nC. 公司型股权投资基金参与主体主要为投资者和基金管理人\nD. 公司型股权投资基金采取有限责任公司或股份有限公司形式",
            "answer": "A",
            "explain": "本题考查公司型基金。A选项表述错误，公司型基金可以由公司管理团队自行管理或者委托专业的基金机构担任基金管理人。"
        },
        {
            "title": "对于开展估值核算业务的服务机构，下列说法错误的是（　　）。",
            "question": "A. 基金服务业务所涉及的客户资产应独立于基金服务机构的自有财产\nB. 基金服务机构破产时，基金服务业务所涉及的基金资产和客户资产不属于其破产财产\nC. 基金服务业务所涉及的基金资产应独立于基金服务机构的自有资产\nD. 基金服务机构同时提供托管服务的，服务机构的团队成员可以兼任托管业务团队的职务",
            "answer": "D",
            "explain": "本题考查基金服务业务中可能存在的利益冲突。"
        },
        {
            "title": "增值服务处于投资后管理的重要地位，关于增值服务，以下表述正确的是（　　）。",
            "question": "A. 对于发展较为成熟的被投资企业，增值服务侧重在规范管理、业务开拓、后续再融资等方面\nB. 投资机构协助被投资企业进行后续再融资工作，以便投资机构能够参与被投资企业的后续轮次融资\nC. 对于早期阶段的被投资企业，增值服务侧重在资源导入、兼并收购、上市推动等方面\nD. 主要目的是提升被投资企业的价值，降低投资风险，最终实现投资机构对被投资项目的顺利退出",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "股权投资母基金A近期完成两项投资，一是认购了半年前已工商设立但仍在募集期的股权投资基金B的份额，二是购买了4年前设立的股权投资基金C所持有的投资组合。关于前述业务，以下表述正确的是（　　）。",
            "questions": "I. 对基金B的投资属于母基金的一级投资业务<br>II. 对基金C投资组合的投资属于母基金的直接投资业务<br>III. 母基金A在投资后成为基金B的出资人<br>IV. 母基金A在投资后成为基金C的出资人",
            "question": "A. I、III\nB. I、III、IV\nC. II、IV\nD. II、III",
            "answer": "B",
            "explain": "本题考查母基金。"
        },
        {
            "title": "关于股权投资基金的初步尽职调查与正式尽职调查，以下表述正确的是（　　）。",
            "question": "A. 初步尽调是对项目进行价值判断，以便立项；正式尽调是对项目进行风险判断，以便估值\nB. 初步尽调后，与项目方签署投资框架协议；正式尽调后，与项目方签署投资协议\nC. 初步尽调后，需要提交投资建议书；正式尽调后，由外聘机构提交项目尽调报告\nD. 初步尽调会睛请外部机构参与完成；正式尽调会由内部投资管理小组完成",
            "answer": "B",
            "explain": "本题考查初步尽职调查和尽职调查。"
        }, {
            "title": "股权投资基金管理人在销售股权投资基金时，不得（　　）。",
            "question": "A. 委托第三方机构对基金进行风险评级\nB. 要求投资者书面承诺符合合格投资者条件\nC. 要求投资者填写调查问卷，以了解投资者的风险识别能力\nD. 承诺投资者该基金为保本型基金",
            "answer": "D",
            "explain": "本题考查资金募集的规定。"
        },
        {
            "title": "区域性股权交易市场接受省级人民政府监管，（　　）为区域性市场提供业务指导和服务。",
            "question": "A. 省级人民政府\nB. 中国证监会及其派出机构\nC. 中国证券业协会\nD. 证券交易所",
            "answer": "B",
            "explain": "本题考查区域性股权交易市场。"
        },
        {
            "title": "为更好地对被投资公司实施投资后管理和项目监控，股权投资基金可采取的行动包括（　　）。",
            "questions": "I. 投资工具采用可转换优先股，投后阶段转换为普通股，增加在股东大会和董事会的话语权<br>II. 投资工具采用可转换债券，投后阶段转换为普通股，增加在股东大会和董事会的话语权<br>III. 要求被投公司定期提供业绩报告和财务报表<br>IV. 调查被投公司频繁任免管理人员的原因",
            "question": "A. II、III、IV\nB. I、II、IV\nC. I、II、III、IV\nD. I、II、III",
            "answer": "C",
            "explain": "本题考查项目跟踪与监控的主要方式。"
        },
        {
            "title": "某股权投资基金以投资当年的预计净利润为基数，按10倍的市盈率对目标企业进行投资的估值，基金投资金额为2亿元，投资后持有股权比例为10%，投资当年的预计净利润为（　　）亿元。",
            "question": "A. 2\nB. 1.75\nC. 1.6\nD. 1.8",
            "answer": "D",
            "explain": "本题考查市盈率倍数法估值。"
        },
        {
            "title": "某生产制造企业主要资产包括厂房、机器设备和办公楼，经评估后总的重置全价为6000万元，综合成新率为80%，公司尚有存货，评估后的重量全价为3000万元，综合贬值800万元，按照重置成本法计算该公司股权价值为5100万元，则该公司经调整后的负债金额为（　　）。",
            "question": "A. 2700万元\nB. 3900万元\nC. 1900万元\nD. 3100万元",
            "answer": "C",
            "explain": "本题考查重置成本法。"
        },
        {
            "title": "关于监管机构采取的行政监管措施和行政处罚，下列表述正确的是（　　）。",
            "question": "A. 对行政处罚措施不服的，既可以向复议机关申请复议，也可以向法院提起诉讼，如果对行政复议结果不服的，不能再向法院提起诉讼\nB. 对行政监管措施和行政处罚不服的，可以自收到决定书之日起六个月内向有管辖权的人民法院提起诉讼\nC. 对行政监管措施和行政处罚不服的，可以自收到决定书之日起60天内向复议机关申请复议\nD. 对行政监管措施不服的，只能向复议机关申请复议，不能向人民法院提起诉讼",
            "answer": "C",
            "explain": "本题考查政府监管的处理方式。"
        },
        {
            "title": "股权投资基金管理人应该在下述哪个时间内执行私募基金的备案（　　）。",
            "question": "A. 基金募集完毕后10个工作日内\nB. 基金进行项目投资前20个工作日内\nC. 基金募集完毕后20个工作日内\nD. 基金进行项目投资前的任何时间",
            "answer": "C",
            "explain": "本题考查登记与备案的及时性原则。"
        }, {
            "title": "对于有限合伙型创业投资基金而言，法人合伙人投资于多个符合条件的创业投资企业的，可享受的税收优惠措施有（　　）。",
            "question": "A. 不可合并计算其可抵扣的投资额，也不可合并计算其应分得的应纳税所得额\nB. 不可合并计算其可抵扣的投资额，但可以合并计算其应分得的应纳税所得额\nC. 可抵扣的投资额和应分得的应纳税所得额都可合并计算\nD. 可以合并计算其可抵扣的投资额，但不可合并计算其应分得的应纳税所得额",
            "answer": "C",
            "explain": "如果法人合伙人投资于多个符合条件的有限合伙制创业投资企业，可合并计算其可抵扣的投资额和应分得的应纳税所得额。"
        },
        {
            "title": "关于狭义创业投资基金，以下表述错误的是（　　）。",
            "questions": "I. 创业投资基金不可投资于新三板挂牌企业<br>II. 所投资未上市企业上市后，创业投资基金可以参与其增资<br>III. 创业投资基金通常不会举债用于投资<br>IV. 因单个项目投资金额较小，故创业投资基金一般不需要具备一定规模",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、II、III、IV\nD. II、III、IV",
            "answer": "B",
            "explain": "I项说法错误，新三板挂牌公司属于未上市公司，投资于新三板企业的基金可归为创业投资基金。II项说法错误，通常股权投资基金不得投资二级市场公开交易的股票（不可增资），所投资的未上市企业上市后，股权投资基金所持股份的未转让部分及其配售部分不在此限。"
        },
        {
            "title": "关于项目退出方式，以下说法正确的是（　　）。",
            "questions": "I. 从退出成本的角度来看，清算退出是需要先支付清算费用，剩余部分才能进行分配<br>II. 从退出风险的角度来看，上市转让退出的风险主要表现在企业上市申请是否获批的不确定性和额定期内的股票价格波动<br>III. 从退出效率的角度来看，一般上市转让退出比场外交易市场挂牌的方式效率高<br>IV. 从退出收益的角度来看，一般清算退出的收益较高",
            "question": "A. I、II\nB. III、IV\nC. I、IV\nD. II、III",
            "answer": "A",
            "explain": "I项说法正确，从退出成本的角度来看，清算退出是需要先支付清算费用，剩余部分才能进行分配。II项说法正确，从退出风险的角度来看，上市转让退出的风险主要表现在企业上市申请是否获批的不确定性和额定期内的股票价格波动。"
        },
        {
            "title": "某技术领先的目标公司未来发展前景良好，有销售收入但利润为负数，适用的估值办法是（　　）。",
            "question": "A. 折现现金流估值法\nB. 企业价值/总税前利润总数法\nC. 创业投资估值法\nD. 市销率倍数法",
            "answer": "C",
            "explain": "本题考查创业投资估值法的适用范围。"
        },
        {
            "title": "在合伙协议未作任何特殊约定时，合伙型股权投资基金的合伙人转让其持有的基金份额时，以下正确的选项为（　　）。",
            "questions": "I. 合伙人向本基金其他合伙人转让份额时，仅需通知其他合伙人，不必经过其他合伙人的一致同意<br>II. 合伙人向本基金其他合伙人以外的第三人转让份额时，只要未导致合伙人增加，就不会影响到原有的合伙信任关系<br>III. 合伙人向本基金其他合伙人以外的第三人转让份额时，需经其他合伙人的一致同意，且同等条件下其他合伙人可享有优先购买权",
            "question": "A. I、II\nB. I、II、III\nC. II、III\nD. I、III",
            "answer": "D",
            "explain": "I项正确，合伙人向其他合伙人转让财产份额，不会导致合伙人的增加，也不会破坏原有合伙人之间的信任关系，因此仅需通知其他合伙人，不必经过其他合伙人的一致同意。"
        },
        {
            "title": "A公司高级管理人员甲某，在职期间兼任某竞业公司顾问，被A公司发现，双方协商一致后甲某离职。离职后甲某创办新公司，主营业务与A公司相同，并利用私人关系动员A公司核心技术人员乙某、丙某、辞职创业。若甲某在A公司时已针对入职及离职签订了完整的竞业禁止协议，则属于违反竞业禁止条款的行为是（　　）。",
            "questions": "I. 甲在A公司任职期间兼任A公司竞争对手的职位<br>II. 甲离职后创办的新公司与A公司有竞争关系<br>III. 甲离职后加入上下游企业任职高级管理人员<br>IV. 甲离职后劝诱A公司乙某丙某离职",
            "question": "A. I、II、IV\nB. I、II\nC. I、III、IV\nD. II、III",
            "answer": "A",
            "explain": "本题考查竞业禁止条款。"
        }, {
            "title": "股权投资基金管理人可以（　　）。",
            "question": "A. 在电视上公开宣传管理团队\nB. 向投资者承诺基金保本\nC. 以群发手机短信的形式推介基金产品信息\nD. 向投资者承诺保证基金最低收益率",
            "answer": "A",
            "explain": "本题考查宣传推介禁止性行为。A选项符合题意，基金募集机构可以通过合法途径公开宣传下列信息：私募基金管理人的品牌、发展战略、投资策略、管理团队、高管信息；中国基金业协会公示的已备案私募基金的基本信息。"
        },
        {
            "title": "私募基金管理人提供的登记申请材料完备的，中国证券投资基金业协会应当自收到登记材料之日起20个工作日内以（　　）方式，为私募基金管理人办结登记成功手续。",
            "question": "A. 电话通知\nB. 现场公示\nC. 网站公示\nD. 纸牌公告",
            "answer": "C",
            "explain": "本题考查基金管理人登记。基金管理人提交的登记申请材料完备的，基金业协会应该自收齐登记材料之日起20个工作日内，以通过网站公示基金管理人基本情况的方式，为基金管理人办结登记手续。"
        },
        {
            "title": "关于相对估值法可比倍数法，以下表述错误的是（　　）。",
            "question": "A. 一般情况下，市净率倍数法可应用于为银行业企业进行估值\nB. 市盈率倍数法估值时，盈利数据所属的时间通常有三种选择：一是最近一个完整会计年度的历史数据；二是最近十二个月的数据；三是预测年度的盈利数据\nC. 市销率倍数法主要适用于销售成本率较为稳定的收入驱动型企业，如电子商务、商业服务等公司\nD. 对重资产企业进行估值时，企业价值/息税折旧摊销前利润的数法优于企业价值/息税折旧摊销前利润的数法",
            "answer": "D",
            "explain": "本题考查常用的相对估值法。A选项说法正确，市净率倍数法比较适用于资产流动性较高的金融机构，因为这类企业的净资产账面价值更加接近市场价值。例如，银行业的估值通常会用市净率倍数法。"
        },
        {
            "title": "投资机构A对项目企业B实施投资后，为及时获取企业信息，机构A的投资经理可采取的方式包括（　　）。",
            "questions": "I. 作为职工代表监事，参加被投资企业的监事会<br>II. 请被投资企业提供与企业经营状况相关的报告<br>III. 采取电话或会面、到被投资企业实地考察等方式与企业管理人员沟通接触<br>IV. 作为董事会观察员，参与被投资企业董事会事项的讨论",
            "question": "A. I、II、III\nB. II、III、IV\nC. II、III\nD. I、III、IV",
            "answer": "B",
            "explain": "本题考查投资后阶段信息获取的渠道。"
        },
        {
            "title": "关于投资协议的保密条款，以下表述错误的是（　　）。",
            "question": "A. 保密义务是双方共同的义务，目标公司同样承担有未经投资人同意不得向第三方泄露公司未公开的技术、产品及市场信息的保密义务\nB. 保密条款需约定违约责任\nC. 股权投资基金在对目标公司尽职调查过程中与目标公司所沟通的尽调流程、估值意见等属于保密信息的具体内容\nD. 保密条款通常约定保密期限",
            "answer": "A",
            "explain": "本题考查投资协议的保密条款。A选项说法错误，保密条款是指标的法律或监管机构要求的信息披露外，接触面双方对在股权投资交易中知悉的对方商业秘密承担保密义务，未经对方书面同意，不得向第三方泄露。注意是对方商业秘密。"
        },
        {
            "title": "某股权投资基金的管理人未按时在信息披露系统报送2018年第三季度以及2019年第一季度的信息披露报告，以下表述错误的是（　　）。",
            "question": "A. 该基金管理人整改完毕前，中国证券投资基金业协会将暂停受理其基金备案申请\nB. 该基金管理人的异常情况将通过中国证券投资基金业协会信息公示平台对外公示\nC. 该基金管理人整改完毕后，将立即恢复正常机构公示状态\nD. 该基金管理人将被中国证券投资基金业协会列入异常机构名单",
            "answer": "C",
            "explain": "本题考查《关于加强私募基金信息披露自律管理相关事项的通知》。"
        }, {
            "title": "某省证监局对辖区内一家股权投资基金现场检查后，发现其违反有关法规，决定对其罚款100万元。该基金管理人认为处罚过重，可采取的措施有（　　）。",
            "questions": "I. 向仲裁机构申请仲裁<br>II. 向该省金融办申请行政复议<br>III. 向人民法院提起诉讼<br>IV. 向中国证监会申请行政复议",
            "question": "A. II、IV\nB. I、III\nC. I、II\nD. III、IV",
            "answer": "D",
            "explain": "本题考查政府管理的行政处罚。"
        },
        {
            "title": "关于企业自由现金流折现模型，以下表述正确的是（　　）。",
            "question": "A. 企业自由现金折现模型用于计算股权价值\nB. 计算企业自由现金流，无需考虑折旧和摊销的影响\nC. 企业自由现金流量指公司在保证正常运营的情况下，可以向股东进行自由分配的现金流\nD. 企业自由现金流折现模型中的折现率为加权平均资本成本",
            "answer": "D",
            "explain": "本题考查企业自由现金流折现模型。A选项说法错误，企业自由现金流折现模型得到的是企业价值。B选项说法错误，企业自由现金流(FCFF)=息税前利润+调整的所得税+折旧+摊销+营运的资金增加+长期经营性负债的增加-长期经营性资产的增加-资本性支出。C选项说法错误，企业自由现金流是指公司在保持正常运营的情况下，可以向所有出资人（股东和债权人）进行自由分配的现金流。D选项说法正确，企业自由现金流折现模型中的折现率为加权平均资本成本。"
        },
        {
            "title": "某股权投资基金于2012年1月1日成立。截至2016年12月31日的净资产净值为5亿元，各年度投资者缴款和分配金额如下所示，则基金已分配收益倍数为（　　）。",
            "question": "A. 0.67\nB. 1.29\nC. 1.5\nD. 0.77",
            "answer": "B",
            "explain": "本题考查已分配收益倍数。"
        },
        {
            "title": "某企业2016年财报数据中净资产为2000万元，销售收入为1800万元，净利润为1200万元。如果以2016年财报数据为基准，采用市盈率倍数法计算估值，P/E倍数为5时，计算该公司股权价值为（　　）。",
            "question": "A. 9000万元\nB. 7000万元\nC. 6000万元\nD. 10000万元",
            "answer": "C",
            "explain": "本题考查市盈率倍数法的计算。市盈率(P/E)倍数反映了一家公司的股权价值相对其净利润的倍数。市盈率倍数法的计算公式为:股权价值=净利润×市盈率倍数，已知净利润为1200万元，市盈率倍数为5倍，代入公式:股权价值=1200×5=6000（万元）。"
        },
        {
            "title": "股权投资基金托管人的职责不包括（　　）。",
            "question": "A. 开展投资监督\nB. 基金份额登记\nC. 确保基金财产的完整与独立\nD. 对所托管的不同基金财产分别设置账户",
            "answer": "B",
            "explain": "本题考查基金托管人的职责。基金托管人对基金资产进行保管并对基金管理人进行监督，具体来说，基金托管人主要履行下列职责：（1）安全保管基金财产；（2）按照规定开设基金资金账户；（3）对同一基金管理人所托管的不同基金的资金分别设置账户，确保各基金资金账户的独立；（4）将托管资金与基金托管机构自有财产严格分开。"
        },
        {
            "title": "申请私募基金管理人登记的机构，必须纳入《私募基金管理人登记法律意见书》的有（　　）。",
            "questions": "I. 是否被列入失信被执行人名单<br>II. 是否与其他机构签署基金外包服务协议<br>III. 高管人员是否受到行业协会的纪律处分<br>IV. 高管人员是否具备基金从业资格",
            "question": "A. III、IV\nB. I、II、III、IV\nC. I、II\nD. I、III、IV",
            "answer": "B",
            "explain": "本题考查法律意见书的内容。"
        }, {
            "title": "某股权投资基金A为合伙型基金，合伙协议约定，A基金目标以缴出资额为10亿人民币，主要对境内设立的优质子基金进行投资，子基金的投资方向为新能源领域，A基金向中国证券投资基金业协会备案时，应派送的信息和材料包括（　　）。",
            "questions": "I. 目标认缴出资额<br>II. 投资方向<br>III. 合伙协议营业执照正副本复印件<br>IV. 基金类别",
            "question": "A. I、II、IV\nB. I、III\nC. I、II、III、IV\nD. II、III",
            "answer": "C",
            "explain": "本题考查基金备案的内容。"
        },
        {
            "title": "某股权投资基金运行时，发生（　　）时，该基金管理人应当在5个工作日内向中国证券投资基金业协会报告。",
            "question": "A. 基金托管人有重大负面新闻\nB. 基金投资的某一项目公司发生亏损\nC. 基金管理人变更\nD. 基金净值发生变化",
            "answer": "C",
            "explain": "本题考查登记与备案的内容。基金运行期间，如发生以下重大事项的，基金管理人应当在5个工作日内向基金业协会报告：（1）基金合同发生重大变化；（2）基金发生清盘或清算；（3）基金管理人、基金托管人发生变更。"
        },
        {
            "title": "股权投资基金的业绩报酬通常直接分配给（　　）。",
            "question": "A. 基金投资者\nB. 基金管理人\nC. 基金管理团队\nD. 基金服务机构",
            "answer": "B",
            "explain": "本题考查基金的收益分配。B选项符合题意，为建立对管理人的激励机制，股权投资基金的管理人通常参与基金收益的分配，管理人因为其管理可以获得相当于基金利润一定比例的业绩报酬。"
        },
        {
            "title": "假如某股权投资基金于2010年成立，募集规模为8亿元，截止2015年末的资产净值为8亿元，各年度投资者缴款和分配金额如下表所示：则预计投资者在2016年能获得分配资金为（　　）。",
            "question": "A. 2\nB. 3\nC. 12.8\nD. 8.4",
            "answer": "B",
            "explain": "本题考查已分配收益倍数的计算。2015年已分配收益倍数DPI=(D0+D1+D2+...+Dn)/(PI0+PI1+PI2+...+PIn)=(0.5+1.5+1.5+2.5)/(2.5+2.5+3)=0.75;2016年已分配收益倍数(1+50%) x0.75=1.125;则2016年能获得分配资金1.125x8-6=3。"
        },
        {
            "title": "某企业2015年实际净利润2000万元，折旧等非现金费用合计300万元，支付借款利息费用合计200万元，固定资产投资支出1000万元，营运资本净增加500万元，所得税率为25%。该企业2015年度企业自由现金流(FCFF)为（　　）。",
            "question": "A. 900万元\nB. 1950万元\nC. 950万元\nD. 1500万元",
            "answer": "C",
            "explain": "本题考查企业自由现金流的计算。企业自由现金流(FCFF)=息税前利润(EBIT)-调整的所得税+折旧+摊销-营运资金的增加+长期经营性负债的增加-长期经营性资产的增加-资本性支出。(息税前利润-调整的所得税)=净利润+[利息x(1-所得税率)]故FCFF=2000+[200x(1-25%)]+300-(1000+500)=950（万元）。"
        },
        {
            "title": "某有限责任公司型股权投资基金于2013年6月1日成立，基金实缴规模2亿元，存续期限5年，合计投资项目5个，股东甲实缴出资2000万元，公司章程约定按实缴比例进行收益分配，以下表述错误的是（　　）。",
            "question": "A. 2017年底5个投资项目全部实现退出，基金可以安排清算\nB. 如果截至清算时所有项目实现退出3亿元，不考虑税费，股东甲可获得分配3000万元\nC. 基金存续过程中可以以分红金额派发新股的形式对股东进行收益分配\nD. 2018年5月31日基金到期，即使部分项目没有实现退出，基金也可以安排清算",
            "answer": "C",
            "explain": "本题考查公司型股权投资基金的收益分配和清算退出。A、D选项说法正确，一般地，当公司型股权投资基金的全部投资项目都已到期退出，营业期限届满或者出现其他公司章程规定的解散事由时，公司型股权投资基金应当清算退出。"
        }, {
            "title": "以下选项中一般不属于董事会权利的是（　　）。",
            "question": "A. 制定公司的利益分配方案和弥补亏损方案\nB. 审议批准公司的年度财务预算方案、决算方案\nC. 决定公司的经营计划和投资方案\nD. 决定公司内部管理机构的设置",
            "answer": "B",
            "explain": "本题考查董事会的职责。根据《公司法》第47条规定，董事会具体行使下列职权：（1）负责召集股东会，并向股东会报告工作；（2）执行股东会的决议；（3）决定公司的经营计划和投资方案；（C选项属于）"
        },
        {
            "title": "对于开展估值核算业务的服务机构，下列说法错误的是（　　）。",
            "question": "A. 基金服务业务所涉及的客户资产应独立于基金服务机构的自有财产\nB. 基金服务机构破产时，基金服务业务所涉及的基金资产和客户资产不属于其破产财产\nC. 基金服务业务所涉及的基金资产应独立于基金服务机构的自有资产\nD. 基金服务机构同时提供托管服务的，服务机构的团队成员可以兼任托管业务团队的职务",
            "answer": "D",
            "explain": "本题考查基金服务业务中可能存在的利益冲突。A、C选项说法正确，基金服务业务所涉及的基金财产和投资者财产应当独立于基金服务机构的自有财产。B选项说法正确，基金服务机构破产或清算时，基金服务业务所涉及的基金财产和投资者财产不属于其破产或清算财产。D选项说法错误，基金托管人不得被委托担任同一基金的基金服务机构，除非该托管人能够将其托管职能和基金服务职能进行分离，恰当地识别、管理、监控潜在的利益冲突，并披露给投资者。"
        },
        {
            "title": "下列不属于反映被投资企业管理状况的指标是（　　）。",
            "question": "A. 股东关系与公司治理\nB. 主要产品的市场前景\nC. 重大经营管理问题\nD. 经营风险控制情况",
            "answer": "B",
            "explain": "本题考查投资后项目监控的管理指标。项目跟踪与监控的常用指标包括经营指标、管理指标和财务指标。投资后项目监控管理指标主要包括：（1）公司战略与业务定位；（2）经营风险控制情况。"
        },
        {
            "title": "关于股权投资基金行业自律组织的作用，以下表述错误的是（　　）。",
            "question": "A. 自律组织可以发挥行业监管职能，促进行业合规经营\nB. 自律组织可以促进会员忠实履行受托义务和社会责任，推动行业持续稳定健康发展\nC. 自律组织可以发挥行业与政府间的桥梁和纽带作用，维护行业合法权益\nD. 自律组织可以提供行业服务，促进行业交流和创新",
            "answer": "A",
            "explain": "本题考查股权投资基金行业自律组织的作用。股权投资基金行业自律组织的作用包括：B. 自律组织可以促进会员忠实履行受托义务和社会责任，推动行业持续稳定健康发展；C. 自律组织可以发挥行业与政府间的桥梁和纽带作用，维护行业合法权益；D. 自律组织可以提供行业服务，促进行业交流和创新。"
        },
        {
            "title": "关于改制上市，以下表述正确的是（　　）。",
            "questions": "I. 在企业上市中，企业改制是指以在资本市场公开发行和交易股票为目的而进行的企业组织结构、资本资产等方面的改组行为<br>II. 企业改制、上市的主要中介机构，包括证券公司（券商）、会计师事务所、律师事务所等<br>III. 在改制阶段，企业为有限责任公司的应依法改制为股份有限公司，并取得营业执照<br>IV. 改制是公司上市的必经阶段",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. I、II、III\nD. II、III、IV",
            "answer": "A",
            "explain": "本题考查境内首次公开发行上市流程中的改制阶段。"
        },
        {
            "title": "中国证券投资基金业协会将暂停受理管理人基金产品备案申请的情况包括（　　）。",
            "questions": "I. 基金管理人未按时履行季度、年度和重大事项信息报送更新义务的<br>II. 已登记的基金管理人未按要求提交经审计的年度财务报告<br>III. 已登记的基金管理人被列入企业信用信息公示系统，严重违法企业公示名单的",
            "question": "A. I、III\nB. II、III\nC. I、II\nD. I、II、III",
            "answer": "D",
            "explain": "本题考查暂停受理私募基金产品备案申请的情况。"
        }, {
            "title": "不违反禁止性规则，可以担任股权投资基金管理人高管人员包括（　　）。",
            "question": "A. 担任破产清算的公司的经理，对公司破产负有个人责任的，自该公司破产清算完结之日起已满二年\nB. 因涉嫌非法集资正在接收监管机构调查\nC. 因所经营的公司操纵股价被处以市场禁入措施未逾三年\nD. 因所经营的公司逃税被处以有期徒刑，执行期满超过五年",
            "answer": "D",
            "explain": "申请机构的高管人员最近三年存在重大失信记录，或最近三年被中国证监会采取市场禁入措施，协会将不予登记。ABC选项均未满3年，不能担任股权投资基金管理人高管人员。"
        },
        {
            "title": "在投资后，股权投资基金对被投资企业监控的主要方式不包括（　　）。",
            "question": "A. 跟踪协议条款的执行情况\nB. 监控被投资企业财务状况\nC. 参与被投资企业重大经营决策\nD. 委派专门财务人员进驻被投资企业进行财务监控",
            "answer": "D",
            "explain": "投资后项目监控的主要方式包括：（1）跟踪协议条款执行情况；（2）监控被投资企业财务状况；（3）参与被投资企业重大经营决策。"
        },
        {
            "title": "企业上市申报审核阶段的相关工作描述错误的是（　　）。",
            "question": "A. 中国证监会受理申请文件后，对发行人申请文件的合规性进行初审\nB. 发行人将招股说明书（申报稿）在中国证监会网站预披露的时间是发行人对证监会反馈意见回复后\nC. 中国证监会收到申请文件后作出是否受理的决定，未按要求制作申请文件的，不予受理\nD. 中国证监会根据反馈回复继续审核，召开初审会，形成初审报告",
            "answer": "B",
            "explain": "本题考查企业上市申报审核阶段的相关工作。"
        },
        {
            "title": "X药业公司处于高速成长阶段，甲基金拟对X药业公司进行B轮投资，甲基金的业务尽职调查工作应重点关注的事项有（　　）。",
            "questions": "I. 公司管理团队<br>II. 公司已上市产品和储备产品<br>III. 公司的市场环境及发展战略<br>IV. 公司的未来上市地选择<br>V. 公司的税收及政府优惠政策",
            "question": "A. I、II、III、V\nB. I、II、III\nC. I、II、III、IV\nD. II、III、V",
            "answer": "B",
            "explain": "本题考查业务尽职调查的侧重点。"
        },
        {
            "title": "设立政府引导基金的主要目的是（　　）。",
            "question": "A. 优化创业投资资本配置，克服其市场配置失灵问题\nB. 通过股权投资及后续退出获取高额回报\nC. 投资境外企业，增强海外资产配置\nD. 通过股权投资的形式获得被投资企业的控制权",
            "answer": "A",
            "explain": "本题考查政府引导基金的宗旨。"
        },
        {
            "title": "股权投资基金管理人违反《私募投资基金信息披露管理办法》时，中国证券投资基金业协会可采取如下哪些自律管理措施（　　）。",
            "questions": "I. 撤销基金管理人登记<br>II. 要求基金披露义务人参加强制培训<br>III. 取消直接负责的主管人员的基金从业资格<br>IV. 情节严重的移交中国证监会处理",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. I、III、IV\nD. I、II、III",
            "answer": "A",
            "explain": "本题考查信息披露的自律管理措施。"
        }, {
            "title": "基金托管人的主要职责，以下表述错误的是（　　）。",
            "question": "A. 参与制定基金所投资企业发展战略\nB. 将托管资金与基金托管机构自有财产严格分开\nC. 按照规定开设基金资金账户\nD. 安全保管基金财产",
            "answer": "A",
            "explain": "本题考查基金托管人的职责。基金托管人主要履行下列职责：B. 将托管资金与基金托管机构自有财产严格分开；C. 按照规定开设基金资金账户；D. 安全保管基金财产。"
        },
        {
            "title": "某股权投资基金的管理人正在向投资者进行风险揭示，以下做法正确的是（　　）。",
            "questions": "I. 基金管理人向投资者口头揭示特殊风险，未要求投资者签署风险揭示书<br>II. 基金管理人在投资者签署基金合同之前与投资者签署风险揭示书<br>III. 基金管理人聘请甲公司为该基金提供估值核算服务，基金管理人将其作为一般风险进行揭示<br>IV. 投资者对基金运营风险有疑问，基金管理人就此向投资者进一步解释说明",
            "question": "A. I、II\nB. II、III\nC. I、III\nD. II、IV",
            "answer": "D",
            "explain": "本题考查基金的风险揭示。"
        },
        {
            "title": "假设股权投资基金按照12%的折现率计算，基金净现值为2亿元，按照15%的折现率计算，基金净现值为1亿元，按照18%的折现率计算，基金净现值为-0.5亿元。则基金当前内部收益率更接近（　　）。",
            "question": "A. 13%\nB. 10%\nC. 16%\nD. 19%",
            "answer": "C",
            "explain": "本题考查内部收益率。内部收益率是指截至某一特定时点，倒推计算至基金成立后第一笔现金流产生时，基金资金流入现值加上资产净值现值总额与资金流出现值总额相等，即净现值等于零时的折现率。已知按照15%的折现率计算，基金净现值为1亿元，按照18%的折现率计算，基金净现值为-0.5亿元。则证明折现率在15%与18%之间，基金净现值为零。"
        },
        {
            "title": "股权投资基金业务案机构保存投资者适当性管理及基金募集业务相关材料的记录及其他相关材料，保存期限自基金（　　）之日起不得少于10年。",
            "question": "A. 设立\nB. 募集完成\nC. 清算终止\nD. 开始募集",
            "answer": "C",
            "explain": "本题考查股权投资基金的档案管理。募集机构应当妥善保存投资者适当性管理以及其与基金募集业务相关的记录及其他相关资料，保存期限自基金清算终止之日起不得少于10年。"
        },
        {
            "title": "某大型企业拟发起设立一只产业投资基金，该企业的做法符合规定的是（　　）。",
            "question": "A. 经过资产调查向公司10名高级管理人员发送投资倡议书\nB. 规定投资的员工最少需要投资10万元\nC. 向全公司的1000名员工发起投资倡议书\nD. 强制要求中级以上的管理人员进行投资",
            "answer": "A",
            "explain": "本题考查资金募集管理。A选项说法正确，B选项说法错误，资金募集要做到卖者有责，“责”体现为合格投资者的审查确认，对相关信息的充分披露，对投资者意愿的充分尊重，对监管部门规范要求的充分遵守。C选项说法错误，募集阶段要守住合格投资者募集底线，不得向非合格投资者募集。"
        },
        {
            "title": "在契约型股权投资基金中，（　　）应当按照基金合同的约定，向基金份额持有人提供基金信息。",
            "question": "A. 基金管理人/基金销售机构\nB. 基金销售机构/基金份额登记机构\nC. 基金管理人/基金托管人\nD. 基金管理人/基金份额登记机构",
            "answer": "C",
            "explain": "本题考查信托（契约）型股权投资基金。股权投资基金的基金合同应当包含信息披露的具体安排，包括信息披露义务人向投资者进行信息披露的内容、披露频度、披露方式、披露责任以及信息披露渠道等事项，信息披露义务人应当按照基金合同的约定进行信息披露。"
        }, {
            "title": "通常会触发投资协议中的回售条款的情形为（　　）。",
            "question": "A. 企业未能在投资协议约定的期限内完成上市退出\nB. 企业出现业务违约事件，向投资者如实披露信息\nC. 公司管理层离职，控制权没有发生变化\nD. 经股东大会同意，企业修改公司的章程",
            "answer": "A",
            "explain": "本题考查回售权条款的触发条件：（1）业绩指标触发条件业绩不达标。"
        },
        {
            "title": "与已备案的股权投资基金相比，未备案的股权投资基金（　　）。",
            "question": "A. 所投资公司首次公开发行会受到限制\nB. 投资收益比已备案股权投资基金低\nC. 影响被投资公司的企业性质\nD. 投资分红比例比已备案私募股权投资基金低",
            "answer": "A",
            "explain": "本题考查基金备案的要求。A选项符合题意，证监会监管明确，未完成备案基金不能参与（拟）上市公司发行业务和并购重组。B、D选项不符合题意，B、D选项属于预测收益，已备案与未备案的股权投资基金收益不能预测。"
        },
        {
            "title": "并购基金投资标的的特点不包括（　　）。",
            "question": "A. 优先寻找拥有先进技术但运营质量较差的企业\nB. 比较偏向于已形成一定规模和产生稳定现金流的成熟企业\nC. 更加倾向于价值被低估的企业\nD. 优先投资科技型初创企业",
            "answer": "D",
            "explain": "本题考查并购基金投资标的的特点。A选项包括，一些并购基金倾向于在目标行业内寻找拥有先进技术或商业模式但运营质量较差的企业作为并购对象。"
        },
        {
            "title": "某企业的税前债务成本为10%，股权资本成本为20%，资本结构为1/1，若该企业所得税税率为25%，则该企业的加权平均资本成本为（　　）。",
            "question": "A. 12.5%\nB. 13.75%\nC. 15%\nD. 11.25%",
            "answer": "B",
            "explain": "已知税前债务成本kd为10%，股权资本成本ke为20%，所得税税率t为25%。付息债务的市场价值D和股权的市场价值E比例为1:1，则D=E。WACC=1/2×10%×(1-25%) + 1/2×20%=13.75%"
        },
        {
            "title": "募集机构可以向下列哪个对象推介私募基金（　　）。",
            "question": "A. 拥有200万元存款，年均收入15万元的中学教师\nB. 持有价值200万元股票，近三年年均收入25万元的股民\nC. 拥有价值500万元别墅，近三年年均收入30万元的律师\nD. 持有100万元国债，近三年年均收入55万元的医生",
            "answer": "D",
            "explain": "本题考查合格投资者的范围。股权投资基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只基金的金额不低于100万元且符合下列相关标准的单位和个人：（1）净资产不低于1000万元的单位；（2）金融资产不低于300万元或者最近三年年均收入不低于50万元的个人。此处的金融资产不包括房屋、土地、汽车等资产。"
        },
        {
            "title": "关于投资协议中董事会席位条款以下表述正确的是（　　）。",
            "question": "A. 董事会席位的数量由中小股东投票决定\nB. 投资方持股达到50%以上才有权提名若干名董事\nC. 根据此条款目标企业可进行控制权分配，保护彼此利益\nD. 可约定目标企业董事会的席位数量且后续不能调整",
            "answer": "C",
            "explain": "本题考查董事会席位条款的定义。董事会席位条款指的是在投资协议中股权投资基金和目标公司之间约定董事会的席位构成和分配的条款，约定目标企业董事会的席位数量、初始分配方案和后续调整规则。由上述定义可知，C选项正确。"
        }, {
            "title": "某地方政府引导基金对其投资的创业投资基金所投项目中符合产业导向或区域导向较强的企业参与投资，该做法是政府引导基金对创业投资基金支持方式中的（　　）。",
            "question": "A. 融资担保\nB. 参股\nC. 风险补偿\nD. 跟进投资",
            "answer": "D",
            "explain": "本题考查政府引导基金的内容。跟进投资是指产业导向或区域导向较强的政府引导基金，通过跟进投资，支持创业投资基金发展并引导其投资方向。"
        },
        {
            "title": "某股权投资基金2017年度投资收益高，该基金管理人向投资人披露时，有以下行为：\nI. 将基金收益信息发送到仅由全体投资人组成的微信群内<br>II. 将基金业绩与同时期的沪深300指数基金收益进行比较<br>III. 将基金管理人内部及照片分享给投资人<br>IV. 将基金业绩发布到微信公众号\n上述行为中违反信息披露禁止性规定的有（　　）。",
            "questions": "I. 将基金收益信息发送到仅由全体投资人组成的微信群内<br>II. 将基金业绩与同时期的沪深300指数基金收益进行比较<br>III. 将基金管理人内部及照片分享给投资人<br>IV. 将基金业绩发布到微信公众号",
            "question": "A. I、II\nB. I、III、IV\nC. II、III、IV\nD. II、IV",
            "answer": "C",
            "explain": "本题考查信息披露的禁止性行为。"
        },
        {
            "title": "关于境内首次公开发行上市的程序，以下表述错误的是（　　）。",
            "question": "A. 发行成功后，发行人需刊登上市公告，在证监会的监督指导下完成上市\nB. 预先披露是IPO必经程序\nC. 发行人需在指定报刊、网站刊登招股说明书及发行公告，组织路演，通过询价程序确定发行价格，按照发行方案发行股票\nD. 必须已经是股份有限公司，才能进入上市辅导阶段",
            "answer": "A",
            "explain": "本题考查境内首次公开发行上市流程。A选项说法错误，股票发行及上市阶段，发行成功后，企业刊登上市公告，在交易所的安排下完成上市交易。"
        },
        {
            "title": "股权投资基金对早期企业的常用估值方法是（　　）。",
            "question": "A. 成本法\nB. 经济增加值法\nC. 贴现现金流法\nD. 相对估值法",
            "answer": "D",
            "explain": "本题考查相对估值法适用范围。D选项符合题意，相对估值法是股权投资基金对早期企业的常用估值方法。"
        },
        {
            "title": "某股权投资基金年度投资人会议对投资人报告了以下内容，其中，违反私募基金信息披露禁止性规定的是（　　）。",
            "question": "A. 本年度基金投资组合新增投资项目五个，投资总额25亿元\nB. 本年度基金退出投资项目3个，总计收回2.2亿元，其中，项目对应投资成本1亿元\nC. 本基金预计三年后实现退出，总收益率30%\nD. 本年度基金向管理人支付基金管理费1，500万元",
            "answer": "C",
            "explain": "本题考查信息披露的禁止性行为。信息披露的禁止性行为包括：（1）公开披露或者变相公开披露；"
        },
        {
            "title": "甲公司注册在A地，投资B地，公司型基金乙和合伙型基金丙，其中A地和B地投资类企业所得税率分别为25%。乙基金和丙基金在某年均向甲公司分配投资收益1000万元，不考虑其他财税因素，甲公司就该两笔收益应向A地缴纳所得税（　　）。",
            "question": "A. 750万元\nB. 500万元\nC. 250万元\nD. 0",
            "answer": "C",
            "explain": "本题考查股权投资基金的基本税负。首先分析甲公司自乙基金取得收益的税收：由题干可知投资者“甲公司”为公司，“乙基金”为公司型基金，公司型基金的税收规则是“先税后分”，从基金投资者层面看，公司型基金的投资者作为公司股东从公司型基金获得的分配是公司税后利润的分配，因此投资者是公司时，以股息红利形式获得分配时按《企业所得税法》规定免税。故甲公司自乙基金获得的收益不需要交税。"
        }, {
            "title": "某国内的股权投资基金使用相对估值法，对本土的A公司进行交易估值，可比B公司在美国上市，相比之下，A公司技术更为先进，用户规模更大，实力更为雄厚，有望很快在国内上市，以下表述正确的是（　　）。",
            "question": "A. A公司的竞争力更强，所以其交易估值高于B公司市值\nB. B公司具有资本市场的流动性，A公司的交易估值低于B公司市值\nC. A公司将在国内上市，国内认知度高，所以其交易估值高于B公司市值\nD. A公司的竞争力更强，B公司具有资本市场的流动性，所以A公司交易估值不能直接跟B公司市值作比较",
            "answer": "D",
            "explain": "本题考查相对估值法的可比公司选取。"
        },
        {
            "title": "股权投资基金对企业进行估值时，以下关于折现现金流法的说法正确的是（　　）。",
            "question": "A. 折现现金流法的基础是现值原则，未来现金流的时间点对企业价值的计算影响不大\nB. 折现现金流估值法多用于以早期和成长阶段企业作为投资标的的风险投资基金\nC. 折现现金流法是通过预测企业未来的现金流，将企业价值定义为企业未来可自由支配现金流的加总和\nD. 股权自由现金流贴现模型中采用的折现率是权益资本成本",
            "answer": "D",
            "explain": "本题考查折现现金流估值法。A选项说法错误，使用折现现金流估值法对目标公司进行价值评估时，一般都要预测目标公司未来每期现金流。B选项说法错误，折现现金流估值法主要适用于目标企业现金流稳定，未来可预测性较高的情形。"
        },
        {
            "title": "根据股权投资基金自律规则，关于股权投资基金管理人的内部治理结构，以下表述正确的是（　　）。",
            "question": "A. 管理公司的法定代表人只能在管理公司任职\nB. 管理公司应当设置董事会\nC. 管理公司应当具备1名专职的财务总监\nD. 管理公司应当至少具备1名专职的合规风控负责人",
            "answer": "D",
            "explain": "本题考查基金管理人的内部治理结构。股权投资基金管理人应建立与其业务特点和规模相匹配的内部治理结构。"
        },
        {
            "title": "某国内股权投资基金全年使用相对估值法，对本土的A公司进行交易估值，可比B公司在美国上市，相比之下，A公司技术更为先进，用户规模更大，实力更为雄厚，有望很快在国内上市，以下表述正确的是（　　）。",
            "question": "A. A公司的竞争力更强，所以其交易估值高于B公司市值\nB. B公司具有资本市场的流动性，所以A公司交易估值低于B公司市值\nC. A公司将在国内上市，国内认知度高，所以其交易估值高于B公司市值\nD. A公司的竞争力更强，B公司具有资本市场的流动性，所以A公司交易估值不能直接跟B公司市值作比较",
            "answer": "D",
            "explain": "本题考查相对估值法的可比公司选取。"
        },
        {
            "title": "关于股权投资基金的投资后管理，以下表述错误的是（　　）。",
            "question": "A. 为避免被投资企业对财务报表进行“调整粉饰”，投资机构应该决定被投资企业的外部审计机构\nB. 投资机构可以对被投资企业的管理团队提出改善建议，必要时协助进行管理团队调整\nC. 投资机构在可能的情况下，应直接参与被投资企业的董事会\nD. 投资机构需定期核查协议条款的执行情况，对执行中存在的重大风险及时采取补救措施",
            "answer": "A",
            "explain": "本题考查项目跟踪与监控的内容。"
        },
        {
            "title": "公司型基金X企业所得税率为25%，投资人A为自然人，投资人B为非金融机构类法人企业，现X基金拟以股息形式分配给投资人A人民币15万元，投资人B人民币25万元，收益均来自于境内某已投项目的股息红利，以下关于相关主体税负描述错误的是（　　）。",
            "question": "A. 投资人A应承担的个人所得税应比照个人所得税法的“股息红利所得”应税项目，适用20%税率，由X基金代缴，金额为人民币3000元\nB. 投资人B应承担的所得税为零\nC. 投资人B所获得的投资收益分配为已投项目股息红利，按X基金企业所得税税率扣税后的分配，不存在双重征税\nD. 投资人A应承担的个人所得税应比照个人所得税法的个体工商户，生产经营所得，应税项目，适用5%-35%的五级超额累进税率，金额为人民币37750元",
            "answer": "D",
            "explain": "本题考查公司型基金的基本税负。《企业所得税法》规定符合条件的居民企业之间的股息、红利等权益性投资收益为免税收入，可以在计算应纳税所得额时减免。"
        },
        {
            "title": "关于股权投资基金的投资业务，下列表述错误的是（　　）。",
            "question": "A. 母基金的一级投资业务，属于长期投资，因此一般会获得比二级投资业务更高的收益\nB. 母基金对非公开发行与和交易的企业股权进行投资不属于母基金的二级投资业务\nC. 母基金的二级投资业务包括对募集设立完成后的存续股权投资基金的投资\nD. 母基金开展一级投资业务是基于对股权投资基金管理人的信任",
            "answer": "A",
            "explain": "股权投资母基金的业务主要包括一级投资、二级投资和直接投资。"
        }, {
            "title": "关于当然合格投资者认定的表述，可能存在错误的是（　　）。",
            "question": "A. 社会保障基金被视为当然合格投资者\nB. 慈善基金等社会公益基金被视为当然合格投资者\nC. A公司为职工设立的企业年金被视为当然合格投资者\nD. 具有十年以上国内投资经验、净资产超过1000万元的投资机构被视为当然合格投资者",
            "answer": "D",
            "explain": "本题考查合格投资者的范围。"
        },
        {
            "title": "机构甲为中国证券投资基金业协会，机构乙为股权投资基金财产保管机构，机构丙为管理人委托的基金份额登记机构，以下属于该基金服务机构的是（　　）。",
            "question": "A. 甲、乙\nB. 丙\nC. 甲、乙、丙\nD. 乙、丙",
            "answer": "D",
            "explain": "本题考查股权投资基金市场服务机构。股权投资基金市场服务机构主要包括基金财产保管机构(机构乙)、基金销售机构、基金份额登记机构(机构丙)、律师事务所、会计师事务所等。中国证券投资基金业协会属于行业自律组织，不属于市场服务机构。"
        },
        {
            "title": "关于合伙型基金，以下表述正确的包括（　　）。",
            "questions": "I. 基金管理人具体负责基金投资运作<br>II. 有限合伙人不参与投资决策<br>III. 有限合伙企业不是企业所得税的纳税主体<br>IV. 合伙型基金不具有独立法人地位",
            "question": "A. I、II、III、IV\nB. I、III、IV\nC. II、III、IV\nD. I、II、III",
            "answer": "A",
            "explain": "本题考查合伙型基金的主要参与主体。"
        },
        {
            "title": "某企业本年度预期经营利润为3000万元，在与某股权投资基金谈判后，双方同意按照该预期利润的15倍市盈率作为融资前估值，由该基金向该企业投资5000万元，投资完成后，该基金所占股份比例为（　　）。",
            "question": "A. 20%\nB. 10%\nC. 11%\nD. 15%",
            "answer": "B",
            "explain": "本题考查市盈率倍数法的计算。计算企业投资前股权价值=净利润×市盈率倍数，已知利润为3000万元，市盈率倍数为15倍，代入公式计算股权价值=3000×15=45000（万元）。"
        },
        {
            "title": "股权投资基金募集流程中的以下（部分）程序按时间顺序排列正确的是（　　）。",
            "questions": "I. 基金风险提示<br>II. 投资冷静期<br>III. 合格投资者确认<br>IV. 投资者适当性匹配",
            "question": "A. IV、I、III、II\nB. III、I、IV、II\nC. C、I、II、III、IV\nD. III、IV、I、II",
            "answer": "A",
            "explain": "本题考查股权投资基金的募集程序。"
        },
        {
            "title": "国内A股IPO市场不包括（　　）。",
            "question": "A. 中小板\nB. 科创板\nC. 创业板\nD. 全国中小企业股份转让系统",
            "answer": "D",
            "explain": "本题考查上市退出的主要市场。"
        }, {
            "title": "关于投资协议的主要条款，以下表述错误的是（　　）。",
            "question": "A. 保护性条款是投资协议和投资框架协议中的常见条款\nB. 设立保护性条款的目的是保护作为小股东的投资者\nC. 完全棘轮条款对作为创始股东的企业家影响较小\nD. 保护性条款通常针对涉及投资者经济利益或公司控制权的重大事项",
            "answer": "C",
            "explain": "本题考查保护性条款与反摊薄条款。A选项说法正确，保护性条款是投资协议和投资框架协议中的常见条款。"
        },
        {
            "title": "下列关于基金管理费的描述，正确的是（　　）。",
            "question": "A. 管理费是按基金实缴出资金额的一定比例收取\nB. 可按基金规模的一定比例收取，也可以采用基金运营预算的机制收取\nC. 管理费是基金托管人向基金投资人收取的费用，按投资规模的一定比例收取\nD. 管理费是基金投资人向基金管理人收取的费用，按投资规模的一定比例收取",
            "answer": "B",
            "explain": "本题考查基金管理费的内容。A选项说法错误，B选项说法正确，管理费可按照基金规模作为计算基数收取，也可以按照合同约定的其他方式计算并收取。"
        },
        {
            "title": "根据有关税收优惠政策，天使投资个人在试点地区投资多个初创科技型企业的，对其中办理注销清算的初创科技型企业，天使投资个人对其投资额的70%尚未抵扣完的，（　　）。",
            "question": "A. 可自注销清算之日起24个月内抵扣天使投资个人转让其他初创科技型企业股权取得的应纳税所得额\nB. 可自注销清算之日起12个月内抵扣天使投资个人转让其他初创科技型企业股权取得的应纳税所得额\nC. 可自注销清算之日起36个月内抵扣天使投资个人转让其他初创型科技型企业股权取得的应纳税所得额\nD. 不可以抵扣天使投资个人转让其他初创型科技型企业股权取得的应纳税所得额",
            "answer": "C",
            "explain": "本题考查国家对创业投资基金在税收上给予特别支持。天使投资个人在试点地区投资多个初创科技型企业的，对其中办理注销清算的初创科技型企业，天使投资个人对其投资额的70%尚未抵扣完的，可自注销清算之日起36个月内抵扣天使投资个人转让其他初创科技型企业股权取得的应纳税所得额。"
        },
        {
            "title": "回购退出情形不包括（　　）。",
            "question": "A. 被投资企业管理层自筹资金购买股权投资基金持有的股份（股权）\nB. 被投资企业的员工集体出资购买股权投资基金持有的股份（股权）\nC. 另一般股权投资基金购买股权投资基金持有的股份（股权）\nD. 被投资企业控股股东自筹资金购买股权投资基金持有的股份（股权）",
            "answer": "C",
            "explain": "本题考查股权回购的分类。股权回购是指通常由被投资企业大股东或创始股东、管理层、员工等出资购买股权投资基金持有的企业股份，从而使股权投资基金实现退出的行为（简单理解为卖回给被投资企业自己人）。"
        },
        {
            "title": "通常股权投资基金的当事人包括（　　）。",
            "questions": "I. 基金投资者<br>II. 基金管理人<br>III. 基金资产保管机构<br>IV. 基金托管人",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. III、IV\nD. II、III",
            "answer": "B",
            "explain": "本题考查股权投资基金当事人。基金当事人，即基金合同的当事人，主要包括基金投资者（I项）、基金管理人（II项）及基金托管人（IV项）。"
        },
        {
            "title": "股权投资基金投资运作中禁止的行为不包括（　　）。",
            "question": "A. 将账户出借给第三方进行交易\nB. 开展借新还旧、期限错配业务\nC. 直接或间接参与场外配资活动或者为场外配资活动提供服务或便利\nD. 与管理人管理的其他基金进行关联交易",
            "answer": "D",
            "explain": "本题考查投资运作中的禁止行为。股权投资基金管理人、股权投资基金托管人、股权投资基金销售机构及其他市场服务机构及其从业人员从事股权投资基金业务，不得有以下行为："
        }, {
            "title": "关于拖售权条款，以下表述正确的是（　　）。",
            "question": "A. 拖售权又称为共同出售权\nB. 行使拖售权的交易下，交易价格以股权投资基金与第三方协商确定的交易价格为准\nC. 拖售权通常与第一拒绝权条款同时出现\nD. 拖售权条款赋予创始股东很大的权力，因此一般创始股东会要求加入投资协议中",
            "answer": "B",
            "explain": "本题考查拖售权条款。A选项说法错误，拖售权又称领售权、强卖权或强制出售权，随售权又称为共同出售权。"
        },
        {
            "title": "根据《关于实施创业投资企业所得税优惠问题的通知》，某创业投资公司以股权形式投资一家中小高新技术企业100万元，2年后，可抵扣的应纳税所得额为（　　）。",
            "question": "A. 100万元\nB. 60万元\nC. 70万元\nD. 50万元",
            "answer": "C",
            "explain": "有限合伙制创业投资企业采取股权投资方式投资于未上市的中小高新技术企业满2年(24个月)的，其法人合伙人可按照对未上市中小高新技术企业投资额的70%抵扣该法人合伙人从该有限合伙制创业投资企业分得的应纳税所得额；当年不足抵扣的，可以在以后纳税年度结转抵扣。"
        },
        {
            "title": "关于相对估值法与折现现金流估值法的比较，下列表述错误的是（　　）。",
            "question": "A. 相对估值法运用起来较为简单\nB. 相对估值法受主观因素影响相对较少\nC. 相对估值法主要适用于创新型子公司估值\nD. 折现现金流估值法主要适用于现金流稳定可预测的公司",
            "answer": "C",
            "explain": "本题考查相对估值法折现现金流估值法的比较。A、B选项说法正确，相对估值法的运用简单，易于理解；主观因素相对较少。"
        },
        {
            "title": "关于企业境外上市，以下表述错误的是（　　）。",
            "question": "A. 境外上市一般包括策划上市方案、准备相关文件、上市申报和公开发行及交易四个步骤\nB. 境外上市外资股包括H股、B股、N股和S股等\nC. 我国企业选择境外直接上市，需要向中国证监会提出申请\nD. 境外上市分为境外直接上市和境外间接上市两种方式",
            "answer": "B",
            "explain": "A选项说法正确，境外上市一般包括策划上市方案、准备相关文件、上市申报和公开发行及交易四个步骤。"
        },
        {
            "title": "股权投资基金在募集过程中的投资冷静期，以下表述正确的是（　　）。",
            "question": "A. 最多72个小时\nB. 最少24个小时\nC. 最少72个小时\nD. 最多24个小时",
            "answer": "B",
            "explain": "除非另有约定，基金合同中应当设置不少于24小时的投资冷静期，在投资冷静期内，尊重机构不得主动联系投资者，但并不禁止投资者主动联系募集机构。"
        },
        {
            "title": "关于总收益倍数，下列说法正确的是（　　）。",
            "question": "A. 总收益倍数体现了投资者的账面回报水平\nB. 总收益倍数是截至某一特定时点，投资者已从基金获得的分配金额与投资者已向基金缴纳金额总和的比\nC. 总收益倍数体现了投资某基金的时间价值\nD. 总收益倍数体现了投资者现金的回收情况",
            "answer": "A",
            "explain": "本题考查总收益倍数的内容。A选项说法正确。"
        }, {
            "title": "是投资协议中最重要的条款之一，因为它直接影响着“谁控制公司”和“当公司被出售时，每个股东能够获得多少现金”这两个问题。",
            "question": "A. 估值条款\nB. 估值调整条款\nC. 董事会席位条款\nD. 保密条款",
            "answer": "A",
            "explain": "本题考查估值条款。估值条款是投资协议中最重要的条款之一，因为它直接影响着“谁控制公司”和“当公司被出售时，每个股东能够获得多少现金”这两个问题。"
        },
        {
            "title": "目前，全国股转系统挂牌股票转让可以采取的方式不包括（　　）。",
            "question": "A. 协议方式\nB. 竞价交易\nC. 做市方式\nD. 中国证监会批准的其他转让方式",
            "answer": "B",
            "explain": "本题考查全国股转系统挂牌后的退出方式。根据《全国中小企业股份转让系统有限责任公司管理暂行办法》的规定，全国股转系统挂牌股票转让可采取协议方式、做市方式或中国证监会批准的其他转让方式。"
        },
        {
            "title": "关于股权投资基金的核算，下列表述错误的是（　　）。",
            "question": "A. 基金托管人对基金管理人编制的财务报告的相关内容负有复核义务\nB. 基金管理人应当对各基金独立建账、独立核算，保证不同基金在名房登记、账户设置、资金拨付、账簿记录等方面相互独立\nC. 股权投资基金会计核算工作的核算主体为基金，会计责任主体为基金管理人\nD. 股权投资基金在运作过程中，可能发生的费用（包括但不限于管理费、托管费、与基金运作相关的其他费用等）应由基金管理人承担承担",
            "answer": "D",
            "explain": "本题考查基金会计核算。A项正确，基金托管人对基金管理人编制的财务报告的相关内容负有复核义务。B、C项正确，股权投资基金会计核算工作的核算主体为基金，会计责任主体为基金管理人，基金管理人应当对所管理的每只基金独立建账，独立核算。"
        },
        {
            "title": "A公司在融资前，企业家持股数量为40000股。前轮投资者以每股3元的价格购买了10000股，后轮投资者以每股2元的价格购买了10000股。在完全棘轮条款下，企业家需向前轮投资者补偿的股票数量为（　　）股。",
            "question": "A. 5000\nB. 10000\nC. 20000\nD. 1000",
            "answer": "A",
            "explain": "本题考查完全棘轮条款。适用完全棘轮条款时，前轮投资者过去投入的资金所换取的股权全部按新的最低价格重新计算，增加的部分由创始股东无偿或以象征性的价格向前轮投资者转让。经计算可得，在完全棘轮条款下，企业家需补偿前轮投资者3×10000/2-10000=5000（股）。"
        },
        {
            "title": "（　　），中央机构编制委员会办公室印发《关于私募股权基金管理职责分工的通知》，明确股权投资基金的监督管理由中国证监会负责，实行适度监管保护投资者权益。",
            "question": "A. 2013年6月\nB. 2014年6月\nC. 2015年6月\nD. 2010年6月",
            "answer": "A",
            "explain": "本题考查政府管理的历史演变。"
        },
        {
            "title": "全国股转系统挂牌股票可采用协议转让退出。在协议转让中，老股东常用的成交方式是（　　）。",
            "question": "A. 撮合成交\nB. 点击成交\nC. 互报成交确认申报\nD. 收盘自动匹配成交",
            "answer": "C",
            "explain": "本题考查协议转让。全国股转系统挂牌股票可采用协议转让退出。在协议转让中，互报成交确认申报是老股东常用的方式，双方通过约定价格、数量和约定。"
        }, {
            "title": "关于企业估值的特点，以下表述错误的是（　　）。",
            "question": "A. 整体价值来源于要素的结合方式\nB. 部分只有在整体中才能体现出其价值\nC. 整体价值只有在运行中才能体现出来\nD. 整体是各部分的简单相加",
            "answer": "D",
            "explain": "本题考查企业估值的特点。A选项说法正确，整体价值来源于要素的结合方式。B选项说法正确，部分只有在整体中才能体现出其价值。C选项说法正确，整体价值只有在运行中才能体现出来。"
        },
        {
            "title": "若采用市盈率倍数法估值，按照10倍市盈率对B公司进行估值，则B公司的股权价值为（　　）。",
            "question": "A. 17亿\nB. 13亿\nC. 14.8亿\nD. 15亿",
            "answer": "D",
            "explain": "本题考查市盈率倍数法的计算。已知净利润为1.5亿元，市盈率倍数为10倍。股权价值=净利润×市盈率倍数=1.5×10=15亿元。"
        },
        {
            "title": "若采用企业价值/息税前利润倍数法估值，按照息税前利润的6倍进行估值，则B公司的公司价值为（　　）。",
            "question": "A. 9亿\nB. 13.2亿\nC. 10.2亿\nD. 12亿",
            "answer": "B",
            "explain": "本题考查企业价值/息税前利润倍数法。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/smgq-2.js